import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

/**
 * Custom hook to check if PM Task Auto Expiration feature is enabled.
 * This feature allows preventive maintenance tasks to be automatically expired
 * when they are missed or overdue.
 */
export function usePMTaskAutoExpirationEnabled() {
  const isEnabled = useFlag<boolean>(FeatureFlag.PMTaskAutoExpiration, false);

  return Boolean(isEnabled);
}
